import { User } from 'lucide-react'
import { cn } from '@/lib/utils'

const badgeClassName =
  'inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide'

type EventVolunteerHeadcountBadgesProps = {
  confirmed: number
  needed: number
  unconfirmed?: number
  showUnconfirmed?: boolean
}

export function EventVolunteerHeadcountBadges({
  confirmed,
  needed,
  unconfirmed = 0,
  showUnconfirmed = false,
}: EventVolunteerHeadcountBadgesProps) {
  return (
    <>
      <span
        className={cn(badgeClassName, 'border-theme-card-border bg-theme-row-2 theme-card-content gap-1')}
        aria-label={`${confirmed}/${needed} volunteers confirmed`}
      >
        <User className="size-3" aria-hidden="true" />
        {confirmed}/{needed}
      </span>
      {showUnconfirmed && (
        <span
          className={cn(badgeClassName, 'border-theme-card-border bg-theme-row-2 theme-card-content')}
          aria-label={`${unconfirmed} unconfirmed volunteers`}
        >
          {unconfirmed} unconfirmed
        </span>
      )}
    </>
  )
}
